import {
  FETCH_DELETE_DETAIL_PROMOTION_SUCCESS,
  FETCH_DETAIL_PROMOTION_SUCCESS,
  FETCH_LIST_PROMOTION_SUCCESS,
} from "redux/ActionTypes/PromotionActionTypes";

const initialState = {
  list: [],
  detail: null,
};

const PromotionReducers = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LIST_PROMOTION_SUCCESS: {
      const newList = [...action.payload];
      return { ...state, list: newList };
    }
    case FETCH_DETAIL_PROMOTION_SUCCESS: {
      const newDetail = { ...action.payload };
      return { ...state, detail: newDetail };
    }
    case FETCH_DELETE_DETAIL_PROMOTION_SUCCESS: {
      return { ...state, detail: null };
    }

    default:
      return { ...state };
  }
};

export default PromotionReducers;
